import React, { useEffect, useState } from 'react';
import './Approvisionnement.css';



const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const TableauAnalyseFaisabilite = () => {
  const [data, setData]                     = useState([]);
  const [loading, setLoading]               = useState(true);
  const [selectedNumero, setSelectedNumero] = useState(null);

  useEffect(() => {                                          // ← ajouter ici
    document.title = 'MYSSA – Analyse faisabilité';
  }, []);



  useEffect(() => {
    setLoading(true);
    fetch(`${API}/analyse_faisabilite`)
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(err => { console.error(err); setLoading(false); });
  }, []);

  // ── Zéro new Date() → zéro décalage UTC ──────────────────
  const formatDatePG = (val) => {
    if (!val) return '';

    // Cas 1 : déjà DD/MM/YYYY → on retourne tel quel
    if (typeof val === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(val)) return val;

    // Cas 2 : ISO "2026-05-09T00:00:00.000Z" ou "2026-05-09"
    // On coupe avant le T puis on réarrange les parties — SANS new Date()
    if (typeof val === 'string') {
      const datePart = val.split('T')[0];          // "2026-05-09"
      const parts    = datePart.split('-');         // ["2026","05","09"]
      if (parts.length === 3) {
        const [year, month, day] = parts;
        return `${day}/${month}/${year}`;           // "09/05/2026"
      }
    }

    return '';
  };

  const HEADERS = ["Type", "Numéro d'offre", "Client", "Date demandée", "Date confirmée"];
  const HIDDEN  = ["Analyse", "ID", "Client_id"];

  const firstLinePerOffre = Object.values(
    data.reduce((acc, item) => {
      if (!acc[item["Numéro d'offre"]]) acc[item["Numéro d'offre"]] = item;
      return acc;
    }, {})
  );

  const secondTableData = selectedNumero
    ? data.filter(item => item["Numéro d'offre"] === selectedNumero)
    : [];

  if (loading) return (
    <div style={{ fontFamily: "'IBM Plex Sans', sans-serif", padding: '20px', color: '#8b7b64' }}>
      Chargement…
    </div>
  );

  return (
    <div style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>

      {/* ── Bandeau titre ── */}
      <div style={{
        position: 'absolute', top: '25px', left: '160px',
        display: 'flex', alignItems: 'center', gap: '10px',
      }}>
        <div style={{
          width: '3px', height: '18px',
          background: 'linear-gradient(180deg, #04202d, #38bdf8)',
          borderRadius: '2px',
        }} />
        <span style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: '20px', fontWeight: '200',
          letterSpacing: '0.12em', textTransform: 'uppercase', color: '#04202d',
        }}>
          Analyse de faisabilité
        </span>
      </div>

      {/* ── Légende ── */}
      <div style={{
        position: 'absolute', top: '25px', right: '40px',
        display: 'flex', gap: '8px', alignItems: 'center',
      }}>
        {[
          { bg: '#e8fdf0', color: '#1a7a40', label: 'OK' },
          { bg: '#fde8e8', color: '#c0392b', label: 'KO' },
          { bg: '#fff9c4', color: '#b7770d', label: 'Partiel' },
        ].map(({ bg, color, label }) => (
          <span key={label} style={{
            padding: '3px 10px', borderRadius: '20px',
            background: bg, color, fontWeight: 700,
            border: `1.5px solid ${color}`, fontSize: '12px',
            fontFamily: "'IBM Plex Mono', monospace",
          }}>
            {label}
          </span>
        ))}
      </div>

      {/* ── Tableau 1 ── */}
      <div
        className="table-container1"
        style={{ marginTop: '150px', marginLeft: '-20px', maxWidth: '1600px', height: '300px', maxHeight: '300px' }}
      >
        <table>
          <thead>
            <tr>
              {HEADERS.map(h => <th key={h}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {firstLinePerOffre.map((item, index) => {
              const dateDem = formatDatePG(item["Date demandée"]);
              const dateCon = formatDatePG(item["Date confirmée"]);
              const isOK    = dateDem && dateCon && dateDem === dateCon;
              return (
                <tr key={index}>
                  {HEADERS.map((header, idx) => {
                    const isDate  = ["Date demandée", "Date confirmée"].includes(header);
                    const isOffre = header === "Numéro d'offre";
                    let cellStyle = {};
                    if (isDate) {
                      cellStyle = isOK
                        ? { backgroundColor: '#d3f9d8', color: '#1a7a40' }
                        : { backgroundColor: '#f9d3d3', color: '#c0392b' };
                    }
                    if (isOffre) {
                      cellStyle = {
                        ...cellStyle,
                        cursor: 'pointer',
                        color: '#3498db',
                        fontWeight: 700,
                        textDecoration: 'underline',
                        ...(selectedNumero === item[header] ? { backgroundColor: '#ebf5fb' } : {}),
                      };
                    }
                    return (
                      <td
                        key={idx}
                        style={cellStyle}
                        onClick={isOffre
                          ? () => setSelectedNumero(item[header] === selectedNumero ? null : item[header])
                          : undefined}
                      >
                        {isDate ? formatDatePG(item[header]) : item[header]}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ── Tableau 2 ── */}
      {selectedNumero && secondTableData.length > 0 && (
        <div
          className="table-container1"
          style={{ marginTop: '100px', marginLeft: '-20px', maxWidth: '1600px', height: '300px', maxHeight: '300px' }}
        >
          <table>
            <thead>
              <tr>
                {Object.keys(secondTableData[0])
                  .filter(h => !HIDDEN.includes(h))
                  .map(h => <th key={h}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {secondTableData.map((item, index) => (
                <tr key={index}>
                  {Object.keys(item)
                    .filter(h => !HIDDEN.includes(h))
                    .map((header, idx) => {
                      let cellStyle = {};

                      if (header === "Date de disponibilité") {
                        cellStyle = parseFloat(item["Quantité manquante"]) === 0
                          ? { backgroundColor: '#d3f9d8', color: '#1a7a40' }
                          : { backgroundColor: '#f9d3d3', color: '#c0392b' };
                      }

                      if (header === "Quantité manquante") {
                        const qteDem = Math.abs(parseFloat(item["Quantité demandée"]));
                        const qteMnq = Math.abs(parseFloat(item["Quantité manquante"]));
                        if (!isNaN(qteMnq) && !isNaN(qteDem)) {
                          if (qteMnq === 0)
                            cellStyle = { backgroundColor: '#d3f9d8', color: '#1a7a40' };
                          else if (qteMnq === qteDem)
                            cellStyle = { backgroundColor: '#f9d3d3', color: '#c0392b' };
                          else
                            cellStyle = { backgroundColor: '#fff3bf', color: '#b7770d' };
                        }
                      }

                      const isDate = ["Date demandée", "Date confirmée"].includes(header);
                      const isDisp = header === "Date de disponibilité";
                      let val = item[header];
                      if (isDate) val = formatDatePG(item[header]);
                      if (isDisp) val = parseFloat(item["Quantité manquante"]) === 0
                        ? '—'
                        : formatDatePG(item[header]);

                      return (
                        <td key={idx} style={cellStyle}>{val}</td>
                      );
                    })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
};

export default TableauAnalyseFaisabilite;